<template>
  <WsMain>
    <WsCRUD
      orderWay="asc"
      orderBy="sequence"
      :label="label"
      :fields="fields"
      :modelName="modelName"
      :showFields="showFields"
    />
  </WsMain>
</template>

<script>
import model from '@/models/meetingTemplateField';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      showFields: [
        'sequence',
        'is_active',
        'name',
        'value',
        'data_field',
        'has_xml',
        'has_html',
        'is_record',
        'module',
        'updated_at',
        'updated_admin',
      ],
    };
  },
};
</script>
